export const DATE_FILTERED_WIDGET_IDS: ReadonlySet<string> = new Set([
  'stat-total-kwh',
  'stat-total-wasted',
  'block-sensor-history',
  'block-work-completed',
  'block-new-work-tickets',
]);
